import { ESTToUTC, nowInEST } from "../../utils/timezone";

export enum AccountingTimePeriodsType {
    WEEK = 'This Week',
    LAST_WEEK = 'Last Week',
    MONTH = 'This Month',
    LAST_MONTH = 'Last Month',
    YEAR = 'This Year',
    LAST_YEAR = 'Last Year',
}

export interface AccountingPeriod {
    type: AccountingTimePeriodsType
    start: Date
    end: Date
}

export const setPeriodRange = (type: AccountingTimePeriodsType) => {
    let start, end;
    const now = nowInEST;

    switch (type) {
        case AccountingTimePeriodsType.WEEK: {
            const weekStart = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate() - now.getDay() + (now.getDay() === 0 ? -6 : 1)
            );

            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekEnd.getDate() + 7);

            start = ESTToUTC(weekStart);
            end = ESTToUTC(weekEnd);
            break;
        }

        case AccountingTimePeriodsType.LAST_WEEK: {
            const weekStart = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate() - now.getDay() + (now.getDay() === 0 ? -6 : 1) - 7
            );

            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekEnd.getDate() + 7);

            start = ESTToUTC(weekStart);
            end = ESTToUTC(weekEnd);
            break;
        }

        case AccountingTimePeriodsType.MONTH:
            start = ESTToUTC(
                new Date(now.getFullYear(), now.getMonth(), 1)
            );
            end = ESTToUTC(
                new Date(now.getFullYear(), now.getMonth() + 1, 1)
            );
            break;

        case AccountingTimePeriodsType.LAST_MONTH:
            start = ESTToUTC(
                new Date(now.getFullYear(), now.getMonth() - 1, 1)
            );
            end = ESTToUTC(
                new Date(now.getFullYear(), now.getMonth(), 1)
            );
            break;

        case AccountingTimePeriodsType.YEAR:
            start = ESTToUTC(
                new Date(now.getFullYear(), 0, 1)
            );
            end = ESTToUTC(
                new Date(now.getFullYear() + 1, 0, 1)
            );
            break;

        case AccountingTimePeriodsType.LAST_YEAR:
            start = ESTToUTC(
                new Date(now.getFullYear() - 1, 0, 1)
            );
            end = ESTToUTC(
                new Date(now.getFullYear(), 0, 1)
            );
            break;

        default:
            start = now;
            end = now;
    }

    end = new Date(new Date(end).setDate(end.getDate()));

    return {
        type,
        start,
        end
    }
}